import { Vue, Component, Watch } from 'vue-property-decorator'
import { store } from '@/store'
import Campaign from './campaign.vue'
import { time } from '@/utils/time'
import { asyncAlert } from '@/galaxy-cruise/components/AsyncAlert'
import { ICampaign } from '@/galaxy-cruise/api_interface'

@Component({
  components: { Campaign },
})
export default class extends Vue {
  get gc() {
    return store.galaxyCruise
  }

  get campaigns() {
    return this.gc.session!.campaigns
  }
}
